export function debugLog(...args) {
	if (process.env.PLUGIN_ENV !== "production") {
		console.debug(...args);
	}
}
